import { useTranslation } from 'react-i18next';
import styles from './CriticalPathTag.module.css';

/**
 * A small gold tag shown next to an activity's title when it sits on the
 * schedule's critical path — a slip there cascades to the project finish date.
 */
export function CriticalPathTag() {
  const { t } = useTranslation();
  return <span className={styles.tag}>{t('activities.criticalPath')}</span>;
}
